'use client';

import React, { useState } from "react";
import PropTypes from "prop-types";

const RadioGroup = ({
  label,
  name,
  options = [],
  className = "",
  defaultChecked,
  ...props
}) => {
  return (
    <div className={`relative ${className}`}>
      {label && (
        <label className="block text-color-2 text-sm ">{label}</label>
      )}
      <div className="flex items-center gap-4">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center cursor-pointer"
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={option.value === defaultChecked}
              className="peer sr-only"
              {...props}
            />
            <span className="block w-4 h-4 border border-color-1 rounded-full peer-checked:border-[var(--accent-light)] peer-checked:bg-[var(--accent-light)] peer-checked:shadow-[inset_0px_0px_0px_3px_var(--primary-bg)] peer-focus-visible:ring-0 peer-focus-visible:ring-[var(--accent-light)] peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-[var(--primary-bg)] transition-all"></span>
            <span className="ml-2 text-color-1 text-sm select-none">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default RadioGroup;
